import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCross32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconCross32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M23.952 6.352A1.2 1.2 0 1 1 25.65 8.05l-7.951 7.952 7.951 7.951a1.199 1.199 0 0 1-1.697 1.697l-7.951-7.951-7.952 7.95a1.2 1.2 0 0 1-1.697-1.697L14.304 16 6.352 8.049A1.2 1.2 0 0 1 8.05 6.352l7.952 7.952z"
            />
        </svg>
    );
}
export default memo(IconCross32);
